import { observable, action, reaction,toJS } from 'mobx'
import moment from 'moment'
//import store
import GlobalControlStore from './GlobalControlStore'
import {
  getAreaFetchHandler,
  getPlannedPathFetchHandler,
  getCleanerPathFetchHandler,
  getInputPromptFetchHandler,
} from '../utils/fetchData'
/*
  isBeforeToday 选择日期是否在今天之前
  needUpdateRoute 是否需要更新清运路线和当前规划路线
  formTips 是否显示起终点表单提示
  formTipsTitle 提示的标题
  formTipsContent 提示的内容
  clearTime 当前选中桶的清运时间
  chooseCan 当前选中的显示信息的桶
  chooseCanInfo 当前选中桶的量
  choosePosition 当前选中桶的position
  historyMap 存储当前显示历史规划路线的显示状态，默认显示一个
  chooseCurrent 默认选中当前智能规划路线
  pathArr 存储已经规划的智能路线
  currentClearWeight 当前智能规划路线的可清运重量
  currentClearDistance 当前智能规划路线的路程
  currentClearRate 当前智能规划路线的效率
  currentClearBuild 当前智能规划路线的创建时间
  showDialog 是否显示规划路径弹窗
  endIsGarage 终点是否是车库，默认是仓库
  carSpace 回收车剩余的空间
  canMinPercentage 回收箱低于此参数不收
  havePoint 是否有起终点
  showList 是否显示搜索列表
  isInputGarge 是否在input车库
  autoObj 自动提示的对象保存
  autoValue 自动提示当前值
  warehouse 仓库值
  garage 车库值
  havePlanningPath 今天是否有规划的路线
  clearRemoveNum 当天实际清运总量
  clearTravelNum 当天实际清运路程
  clearHour 当天实际清运时间
  clearRate 当天实际清运效率
  clearObj 当天实际清运对象
  currentPosition 当前用户的位置
  pageTipsFlag 當前頁面提示框是否显示
*/
class Store {
  @observable pageTipsFlag = false
  @observable pageTipsContent = ''
  @observable currentPosition = {}
  @observable isBeforeToday = false
  @observable formTips = false
  @observable formTipsTitle = ''
  @observable formTipsContent = ''
  @observable clearTime = '--'
  @observable chooseCanInfo = '--'
  @observable choosePosition = []
  @observable chooseCan = '--'
  @observable historyMap = new Map()
  @observable chooseCurrent = true
  @observable pathArr = []
  @observable currentClearWeight = '--'
  @observable currentClearDistance = '--'
  @observable currentClearRate = '--'
  @observable currentClearBuild = '--'
  @observable showDialog = false
  @observable endIsGarage = false
  @observable carSpace = 100
  @observable canMinPercentage = 30
  @observable havePoint = false
  @observable cleanerName = ''
  @observable phone = ''
  @observable area = ''
  @observable cleanerId = null
  @observable date = moment()
  @observable showList = false
  @observable isInputGarge = false
  @observable autoObj = []
  @observable autoValue = ''
  @observable needUpdateRoute = false
  @observable warehouse = ''
  @observable warePosition = {}
  @observable garage = ''
  @observable garagePosition = {}
  @observable havePlanningPath = false
  @observable clearRemoveNum = '--'
  @observable clearTravelNum = '--'
  @observable clearHour = '--'
  @observable clearRate = '--'
  @observable clearObj = {}

  @action.bound
  async getCleanerData() {
    let [res] = await Promise.all([getAreaFetchHandler(this.cleanerId)])
    if (res.ok) {
      let resBody = await res.json()
      this.getCleanerSuccess(resBody)
    } else {
      let resBody = await res.json()
      this.getCleanerFail(resBody)
    }
  }
  @action getCleanerSuccess(data) {
    this.cleanerName = data.name
    this.phone = data.phone
    this.area = data.meta.cleaner.district
    let obj = data.meta.cleaner.meta
    if (obj.start_point && obj.end_point) {
      this.getPathPlanningData()
      this.havePoint = true
      this.warehouse = obj.start_point.address
      this.garage = obj.end_point.address
      this.warePosition = {
        lng: obj.end_point.lng,
        lat: obj.end_point.lat,
      }
      this.garagePosition = {
        lng: obj.start_point.lng,
        lat: obj.start_point.lat,
      }
    } else {
      this.warePosition = {}
      this.garagePosition = {}
      this.havePoint = false
      GlobalControlStore.showLoading = false
    }
  }
  @action getCleanerFail(data) {}
  @action.bound
  async getPathPlanningData() {
    let time = this.date.valueOf()
    let [historyRes, clearRes] = await Promise.all([
      getPlannedPathFetchHandler(this.cleanerId, time),
      getCleanerPathFetchHandler(this.cleanerId, time),
    ])
    if (historyRes.ok) {
      let resBody = await historyRes.json()
      this.getPathPlanningSuccess(resBody)
    } else {
      let resBody = await historyRes.json()
      this.getPathPlanningFail(resBody)
    }
    if (clearRes.ok) {
      let resBody = await clearRes.json()
      this.getClearPathSuccess(resBody)
    } else {
      let resBody = await clearRes.json()
      this.getClearPathFail(resBody)
    }
  }
  getClearPathSuccess(data) {
    GlobalControlStore.showLoading = false
    let pathPoints = data.content.pathPoints
    if (pathPoints.length === 0) {
      this.clearObj = {}
      this.clearTravelNum = '--'
      this.clearRemoveNum = '--'
      this.clearHour = '--'
      this.clearRate = '--'
      this.needUpdateRoute = true
      return
    }
    this.clearObj = data.content
    this.clearTravelNum = (data.content.cost / 1000).toFixed(0)
    let kilogram = 0
    pathPoints.forEach((can) => {
      kilogram += can.kilogram
    })
    this.clearRemoveNum = kilogram.toFixed(0)
    this.clearHour = (
      (pathPoints[pathPoints.length - 1].time - pathPoints[0].time) /
      3600000
    ).toFixed(0)
    this.clearRate = (kilogram / this.clearTravelNum).toFixed(0)
    this.needUpdateRoute = true
  }
  getClearPathFail(data) {}
  getPathPlanningSuccess(data) {
    if (data.content.length === 0) {
      this.pathArr = []
      this.havePlanningPath = false
      this.currentClearWeight = '--'
      this.currentClearDistance = '--'
      this.currentClearRate = '--'
      this.currentClearBuild = '--'
      return
    }
    this.havePlanningPath = true
    this.pathArr = data.content
    let weight = 0,
      last = data.content.length - 1
    data.content[last].pathPoints.forEach((can) => {
      weight += can.kilogram
    })
    this.currentClearWeight = weight.toFixed(0)
    this.currentClearDistance = (data.content[last].cost / 1000).toFixed(0)
    this.currentClearRate = (weight / this.currentClearDistance).toFixed(1)
    this.currentClearBuild = moment(data.content[last].dateTime).format('HH:mm')
    //存储历史路线的显示状态
    let index = 0
    if (data.content.length > 3) {
      index = data.content.length - 3
    }
    for (let i = index; i < data.content.length - 1; i++) {
      this.historyMap.set(data.content[i].id, false)
    }
  }
  getPathPlanningFail(data) {}
}

let PathPlanningStore = new Store()

//自动填充
reaction(
  () => PathPlanningStore.autoValue,
  (value, reaction) => {
    if (!value) return

    let position = toJS(PathPlanningStore.currentPosition)
    getInputPromptFetchHandler(
      value,
      position.lng,
      position.lat,
      (res) => {
        PathPlanningStore.autoObj = res.data
      }
    )
  }
)
export default PathPlanningStore



// WEBPACK FOOTER //
// ./src/store/PathPlanningStore.js